import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const accessControlPath = {
  accessControl: '/erp/access-control',

  // Acceptance Permission - Quyền nghiệm thu
  acceptancePermission: '/erp/access-control/acceptance-permission',
  acceptancePermissionDetail: '/erp/access-control/acceptance-permission' + CRUDPathSegmentEn.DETAIL,
  acceptancePermissionAdd: '/erp/access-control/acceptance-permission' + CRUDPathSegmentEn.ADD,
  acceptancePermissionEdit: '/erp/access-control/acceptance-permission' + CRUDPathSegmentEn.EDIT,

  // Warehouse Permission - Quyền user kho
  warehousePermission: '/erp/access-control/ware-house-permission'
};
export default accessControlPath;
